// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GnXJ","colMin":"styles_colMin__2D-vS"};